/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_Got_OffersInputs */

const tr_geliver_status_got_offers = /** @type {(inputs: Geliver_Status_Got_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler alındı`)
};

const en_geliver_status_got_offers = /** @type {(inputs: Geliver_Status_Got_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers received`)
};

const de_geliver_status_got_offers = /** @type {(inputs: Geliver_Status_Got_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote erhalten`)
};

const ru_geliver_status_got_offers = /** @type {(inputs: Geliver_Status_Got_OffersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения получены`)
};

/**
* | output |
* | --- |
* | "Offers received" |
*
* @param {Geliver_Status_Got_OffersInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_got_offers = /** @type {((inputs?: Geliver_Status_Got_OffersInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_Got_OffersInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_got_offers(inputs)
	if (locale === "de") return de_geliver_status_got_offers(inputs)
	if (locale === "ru") return ru_geliver_status_got_offers(inputs)
	return tr_geliver_status_got_offers(inputs)
});